import React, { useEffect, useState } from "react"
import {
  setDoc,
  doc,
  addDoc,
  collection,
  deleteDoc,
  getDocs,
} from "firebase/firestore"
import { db, storage } from "../../Firebase/config"
import Notify from "../Componentslogic/Usenotifications"
import ReactQuill from "react-quill"
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage"
import "react-quill/dist/quill.snow.css"
import Modal from "react-modal"
import "../../Styles/Addproduct.css"
Modal.setAppElement("#root")
export const SetNotification = () => {
  const [closingTime, setClosingTime] = useState("")
  const [offers, setOffers] = useState([])
  const [offerName, setOfferName] = useState("")
  const [offerDescription, setOfferDescription] = useState("")
  const [offerPrice, setOfferPrice] = useState("")
  const [selectedImage, setSelectedImage] = useState(null)
  const [isEditProductModalOpen, setEditProductModalOpen] = useState(false)

  useEffect(() => {
    const fetchOffers = async () => {
      const querySnapshot = await getDocs(collection(db, "Offers"))
      const offersList = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }))
      setOffers(offersList)
    }
    fetchOffers()
  }, [])

  const handleSubmitNotification = async (e) => {
    e.preventDefault()

    // 🔥 Normalize Empty Notification
    const cleanedNotification =
      closingTime.trim() === "<p><br></p>" ? "" : closingTime.trim()

    try {
      await setDoc(doc(db, "Notification", "4Az1NF5LIxQWdsCwmfXb"), {
        Notification: cleanedNotification,
      })
      Notify("Notification Set successfully!", "success")

      // ✅ Clear the state
      setClosingTime("")
    } catch (error) {
      Notify("Failed!", "error")
    }
  }
  const handleDeleteOffer = async (offerId) => {
    try {
      await deleteDoc(doc(db, "Offers", offerId))
      setOffers((prev) => prev.filter((offer) => offer.id !== offerId))
      Notify("Offer deleted successfully!", "success")
    } catch (error) {
      Notify("Failed to delete offer!", "error")
    }
  }

  const handleSubmitOffer = async (e) => {
    e.preventDefault()
    if (!offerName || !offerDescription || !offerPrice || !selectedImage) {
      Notify("Please fill all fields and select an image!", "error")
      return
    }
    try {
      const storageRef = ref(storage, `Offers/${selectedImage.name}`)
      const uploadTask = uploadBytesResumable(storageRef, selectedImage)

      uploadTask.on(
        "state_changed",
        () => {},
        (error) => {
          Notify("Image upload failed!", "error")
        },
        async () => {
          const downloadURL = await getDownloadURL(uploadTask.snapshot.ref)
          const newOffer = {
            name: offerName,
            description: offerDescription,
            Price: parseFloat(offerPrice),
            imageUrl: downloadURL,
            createdAt: Date.now(),
          }

          const docRef = await addDoc(collection(db, "Offers"), newOffer)
          setOffers((prev) => [...prev, { id: docRef.id, ...newOffer }])

          Notify("Offer added successfully!", "success")
          setOfferName("")
          setOfferDescription("")
          setOfferPrice("")
          setSelectedImage(null)
          setEditProductModalOpen(false)
        }
      )
    } catch (error) {
      Notify("Failed to add offer!", "error")
    }
  }

  return (
    <div className="admin-container">
      {/* ✅ Notification Section */}
      <div>
        <h2 className="mb-3 mt-4">Set Notification</h2>
        <ReactQuill
          value={closingTime}
          onChange={setClosingTime}
          placeholder="What is in your mind!"
          className="quill-editor"
        />
        <button className="btns-Admin mt-4" onClick={handleSubmitNotification}>
          Set Notification
        </button>
      </div>

      {/* ✅ Offers Section */}
      <div className="mt-5">
        <h2>Manage Offers</h2>
        <button
          className="btns-Admin mt-3"
          onClick={() => setEditProductModalOpen(true)}
        >
          + Add Offer
        </button>

        {/* Display Offers */}
        <div className="offers-list">
          {offers.length > 0 ? (
            offers.map((offer) => (
              <div key={offer.id} className="offer-card">
                <img
                  src={offer.imageUrl}
                  alt={offer.name}
                  className="offer-image"
                />
                <div className="offer-info">
                  <h3>{offer.name}</h3>
                  <p>{offer.description}</p>
                  <p>
                    <strong>Price:</strong> {offer.Price} EGP
                  </p>
                  <button
                    className="btns-red p-2"
                    onClick={() => handleDeleteOffer(offer.id)}
                  >
                    Delete
                  </button>
                </div>
              </div>
            ))
          ) : (
            <p className="no-offers">No offers available.</p>
          )}
        </div>
      </div>

      {/* ✅ Offer Modal */}
      {isEditProductModalOpen && (
        <Modal
          isOpen={isEditProductModalOpen}
          onRequestClose={() => setEditProductModalOpen(false)}
          contentLabel="Edit Product"
          style={{
            overlay: {
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              overflow: "auto",
            },
            content: {
              position: "static",
              textAlign: "center",
              inset: "unset",
              width: "700px",
              height: "fit-content",
              padding: "20px",
              borderRadius: "10px",
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
              backgroundColor: "#fff",
            },
          }}
        >
          <h2>Add Offer</h2>
          <form className="p-offer-form" onSubmit={handleSubmitOffer}>
            <input
              type="text"
              className="p-input"
              placeholder="Offer Name"
              value={offerName}
              onChange={(e) => setOfferName(e.target.value)}
              required
            />
            <textarea
              className="p-textarea"
              placeholder="Offer Description"
              value={offerDescription}
              onChange={(e) => setOfferDescription(e.target.value)}
              required
            />
            <input
              type="number"
              className="p-input"
              placeholder="Offer Price"
              value={offerPrice}
              onChange={(e) => setOfferPrice(e.target.value)}
              required
            />
            <input
              type="file"
              className="p-file-input"
              accept="image/*"
              onChange={(e) => setSelectedImage(e.target.files[0])}
              required
            />
            <div className="p-modal-buttons">
              <button type="submit" className="p-btn-add">
                Add Offer
              </button>
              <button
                type="button"
                className="p-btn-cancel"
                onClick={() => setEditProductModalOpen(false)}
              >
                Cancel
              </button>
            </div>
          </form>
        </Modal>
      )}
    </div>
  )
}
